<script>
import {BBadge} from 'bootstrap-vue'
import dateRenderer from "@core/mixins/date-renderer";
export default {
    mixins: [dateRenderer],
    components: {BBadge},
    props: {
        date: {
            default: null
        }
    },
    computed: {
        isOngoing() {
            if (!this.date) {
                return false;
            }

            return (new Date(this.date)) > (new Date());
        }
    }
}
</script>

<template>
    <b-badge :variant="isOngoing ? 'success' : 'danger'">
        {{ renderDate(date) }}
    </b-badge>
</template>
